import { discoveryApiUrl } from "../config";

export interface ServiceEntry {
  service_name: string;
  base_url: string;
}

export interface OwnerInfo {
  node_owner_uid: string;
  owner_name: string;
}

/**
 * discoveryApiUrl is the only address this app knows at deploy time -- see
 * config.ts. Everything else is found through it at runtime, same pattern
 * as kwms-web's own discoveryClient.ts.
 */
export async function findService(name: string): Promise<ServiceEntry> {
  const response = await fetch(`${discoveryApiUrl}/services/${encodeURIComponent(name)}`);
  if (!response.ok) {
    throw new Error(`nodeowner-discovery-api: service "${name}" not found (${response.status})`);
  }
  return response.json();
}

export async function getOwnerInfo(): Promise<OwnerInfo> {
  const response = await fetch(`${discoveryApiUrl}/owner`);
  if (!response.ok) {
    throw new Error(`nodeowner-discovery-api: /owner failed (${response.status})`);
  }
  return response.json();
}

// This deployment's owner never changes underneath a running tab -- one
// build is configured for exactly one owner instance (see config.ts) -- so
// every page can share a single fetch instead of each re-asking
// discovery-api the same question on every mount.
let cachedOwnerInfo: Promise<OwnerInfo> | null = null;

export function getOwnerInfoCached(): Promise<OwnerInfo> {
  if (!cachedOwnerInfo) {
    cachedOwnerInfo = getOwnerInfo().catch((e) => {
      cachedOwnerInfo = null;
      throw e;
    });
  }
  return cachedOwnerInfo;
}
